module.exports = __webpack_public_path__ + "img/logo_b.fe3946df.svg";